export default __webpack_public_path__ + "static/media/logoSimple.598c7abf.png";